const popup = () => {
/*
* rules for age checker popup
*/

    let overlay = document.querySelector(".overlay");
    try {
        let showpopup = false;
        let btnAccept = document.querySelector(".popup-button-valid");

        if (showpopup) {        
            overlay.style.display = "block";
        }
        
        if (getCookie("ageaccept")) {
            showpopup = false;
        }
        
        if (btnAccept) {
            if (!getCookie("ageaccept")) {
                overlay.style.display = "block";
                btnAccept.addEventListener("click", function(e) {
                    e.preventDefault();
                    overlay.style.display = "none";
                    setCookie("ageaccept", "true", 1);
                    showpopup = false;
                    
                });
            }

        } else {
            /**
            * show second popup
            */
            if (!getCookie("popup2") && window.innerWidth > 1024) {
                setTimeout(() => {
                    showpopup = true;
                    overlay.style.display = "block";
                }, 4000);
            }
        }
    }
    catch(e) {}

/*
* rules for best casinos popup
*/
   

    try {
        let popupCloseBtn = document.querySelector(".icon-popup_close");
        let popupLinks = document.querySelectorAll(".popup-link");

        overlay.addEventListener("click", function(e) {
            let target = e.target;

            if( target == popupCloseBtn || target.closest('svg') ) {
               
                overlay.style.display = "none";
                setCookie("popup2", "true", 1);
                showpopup = false;
            }

            for( let i =0; i < popupLinks.length; i++ ) {   
                if( target == popupLinks[i] || target.closest('a') == popupLinks[i] ) {
             
                    e.preventDefault;
                    setCookie("popup2", "true", 1);
                    location.href = popupLinks[i].getAttribute("href");
                }
                
            }
        });
    } catch(e) {}
}

export default popup;